import { render } from "./AreaField.vue?vue&type=template&id=64a18080"
import script from "./AreaField.vue?vue&type=script&lang=js"
export * from "./AreaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__